import type { ContractCategory } from '@/features/contracts';

import type {
  CanalCatalogo,
  OnboardingSelfStep,
  ProdutoCatalogo,
  ProdutoId,
  VolumeCatalogo,
} from '../types';

export const STEPPER_LABELS = ['Empresa', 'Produtos', 'Operação', 'Seu presente'] as const;

export const STEPPER_STEP_ORDER: Partial<Record<OnboardingSelfStep, number>> = {
  empresa: 0,
  produtos: 1,
  operacao: 2,
  criando: 3,
  presente: 3,
};

export const PRODUTOS: ProdutoCatalogo[] = [
  {
    id: 'notificacao',
    titulo: 'Notificação Extrajudicial',
    descricao: 'Notifique e cobre com validade jurídica por e-mail, WhatsApp e carta física.',
    nota: 'Certificado de envio incluído',
    badge: 'Mais usado',
  },
  {
    id: 'lexi',
    titulo: 'Lexi — negociação com IA',
    descricao: 'Um agente que negocia, propõe acordo e fecha por você, dentro das suas alçadas.',
    nota: 'Você define os limites, ela executa',
    badge: 'Novo',
  },
  {
    id: 'mediacao',
    titulo: 'Mediação e Conciliação',
    descricao: 'Sessões conduzidas por mediador da câmara, com acordo assinado digitalmente.',
    nota: 'Entra na lista de espera do lançamento',
    badge: 'Em breve',
  },
  {
    id: 'arbitragem',
    titulo: 'Arbitragem Digital',
    descricao: 'Sentença arbitral com força de título executivo, sem passar pelo Judiciário.',
    nota: 'Cobrança por uso, sem mensalidade',
    badge: null,
  },
];

export const VOLUMES: VolumeCatalogo[] = [
  { id: 'ATE_50', label: 'Até 50 casos', nota: 'Começando agora' },
  { id: 'DE_50_A_500', label: '50 a 500 casos', nota: 'Operação em ritmo' },
  { id: 'DE_500_A_5000', label: '500 a 5.000 casos', nota: 'Volume alto' },
  { id: 'ACIMA_DE_5000', label: 'Mais de 5.000', nota: 'Escala — falamos com você' },
];

export const CANAIS: CanalCatalogo[] = [
  { id: 'INDICACAO', label: 'Indicação' },
  { id: 'BUSCA_GOOGLE', label: 'Busca no Google' },
  { id: 'LINKEDIN_REDES', label: 'LinkedIn / redes' },
  { id: 'EVENTO_PALESTRA', label: 'Evento ou palestra' },
  { id: 'TIME_ARBITRALIS', label: 'Time Arbitralis' },
];

/** Intenção de produto declarada, no vocabulário do core-api (Lexi é a negociação). */
export const PRODUTO_PARA_CATEGORIA: Record<ProdutoId, ContractCategory> = {
  notificacao: 'NOTIFICACAO',
  lexi: 'NEGOCIACAO',
  mediacao: 'MEDIACAO',
  arbitragem: 'ARBITRAGEM',
};

/** Duração do contador que sobe de 0 ao saldo na tela do presente. */
export const BONUS_ANIMACAO_MS = 900;

/**
 * Quem *recebeu* uma notificação não precisa criar conta. O portal do notificado
 * não tem login próprio: entra pelo login comum e cai no painel pelo redirect.
 */
export const ROTA_PAINEL_NOTIFICADO = `/login?redirect=${encodeURIComponent('/portal/dashboard')}`;
export const ROTA_PLATAFORMA = '/';
export const ROTA_LOGIN = '/login';

/**
 * Espelha o saldo do produto Free no catálogo do core-api. A abertura não chama API,
 * então este número muda junto com o catálogo; o saldo real chega na criação da conta.
 */
export const SALDO_PRESENTE_ANUNCIADO = 200;
